import { render } from "./RespondentWaves.vue?vue&type=template&id=bed51568"
import script from "./RespondentWaves.vue?vue&type=script&lang=js"
export * from "./RespondentWaves.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__